import { z } from 'zod';
import { useTranslation } from 'react-i18next';
import { t as tGlobal } from 'i18next';
import { useFormHook } from '@Hooks/index';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';
import {
  getDefaultValueByQuestionId,
  saveEddQuestionToLocalStore,
} from '@Pages/happyFlowPages/eddQuestions/shared.utils';
import { EDD_VERSION } from '@Pages/happyFlowPages/eddQuestions/consts';
import { useBoundStore } from '@Store/useBoundStore';
import { useNavigationManager } from '@Router/useNavigationManager';

import { RoutesMap } from '@Router/router.types';
import { usePostEddData } from '@Pages/happyFlowPages/eddQuestions/hooks/usePostEddData';

export const useAnnualRevenueLogic = () => {
  const { mutateAsync: postEddData, isPending: isPostingEddData } = usePostEddData();
  const { getEddEmbeddedQuestions } = useBoundStore((state) => state);
  const { navigateToNextPage } = useNavigationManager();
  const { t } = useTranslation('eddQuestions');

  const formMethods = useFormHook({
    schemaTitle: 'Annual Revenue',
    formDefaultValues: {
      [EddEmbeddedFields.EDD_ANNUAL_REVENUE]:
        getDefaultValueByQuestionId(EddEmbeddedFields.EDD_ANNUAL_REVENUE) || '',
    },
    formSchema: z.object({
      [EddEmbeddedFields.EDD_ANNUAL_REVENUE]: z
        .string()
        .min(1, { message: tGlobal('enErrors:required') }),
    }),
  });

  const handleSubmit = async () => {
    /** Save to local store */
    saveEddQuestionToLocalStore({
      question: t('organic.annualRevenue.subtitle'),
      questionId: EddEmbeddedFields.EDD_ANNUAL_REVENUE,
      answer: formMethods.getValues(EddEmbeddedFields.EDD_ANNUAL_REVENUE),
    });

    /** Save to Server */
    try {
      await postEddData({
        version: EDD_VERSION,
        results: getEddEmbeddedQuestions(),
      });
      navigateToNextPage(RoutesMap.EDD_ANNUAL_REVENUE);
    } catch (error) {
      /** TODO: Handle error - Check with PM */
      console.error(error);
    }
  };

  return {
    formMethods,
    handleSubmit,
    isLoading: isPostingEddData,
  };
};
